import React, { Component } from 'react';
import styles from './permissions.module.scss';
import classnames from 'classnames';
import { strings } from '../../components/utils/translations';
import API from '../../components/utils/API';
import { Errors } from '../../components/utils/errors';
import { Utils } from '../../components/utils/utils';
import DownloadFileIcon from '../../img/files.png';
import TrashIcon from '../../img/icons/TrashIcon';
import GaragesIcon from '../../img/icons/GaragesIcon';
import CloseIcon from '../../img/icons/closeIcon';
import { ReactComponent as ArrowRightIcon } from '../../img/icons/arrow.right.svg'
import { ReactComponent as NoUsersIcon } from '../../img/icons/person.crop.badge.magnifyingglass.svg'
import CsvTemplate from '../../img/plantilla-de-importacion-usuarios-homyhub.csv';
import { Checkbox, Tabs, Input, Button, Tooltip, notification, Empty } from 'antd';
import PrimaryButton from '../../components/Buttons/primaryButton';
import ImportUsersModal from '../../components/Modal/importUsersModal';
import ProgressSteps from '../../components/ProgressSteps/progressSteps'
import Colors from '../../css/vars.scss'

const TAB_KEY_AGENDA = "agenda"
const TAB_KEY_ADD_MANUAL = "add_manual"
const TAB_KEY_IMPORTED_AGENDA = "imported_agenda"
const TAB_KEY_IMPORTED_MANUAL = "imported_manual"

export default class SelectUsersPermissions extends Component
{
	constructor(props)
	{
		super(props);

		this.state =
		{
			selectedDoors: props.selectedDoors,
			houses: props.houses,
            closePermissions: props.closePermissions,
            users: [],
			selectedAgendaUsers: [],
			usersManuallyUploaded: [],

			name: '',
			email: '',
			phoneNumber: '',

            openImportUserModal: false,

			showDoors: false,
			userId: null,

			filter: "",
			contacts: [],
			agendaSelectedContactsSearch: "",
			manualSelectedContactsSearch: "",
			
			leftPaneActiveTabKey: TAB_KEY_AGENDA,
			rightPaneActiveTabKey: TAB_KEY_IMPORTED_AGENDA
		}
		
		this.isPressingShift = false
		this.searchText = ''
		this.lastCheckedUserId = null
		this.lastUncheckedUserId = null
		
		this.onKeyDown = this.onKeyDown.bind(this)
		this.onKeyUp = this.onKeyUp.bind(this)
	}

    componentDidMount()
	{
		this.getPermissions()
		
		window.addEventListener('keydown', this.onKeyDown)
    	window.addEventListener('keyup', this.onKeyUp)
	}
	static getDerivedStateFromProps(props, state)
	{
		let newState = {}
		
		if (props.selectedDoors && props.selectedDoors != state.selectedDoors)
			newState.selectedDoors = props.selectedDoors
		
		if (props.houses && props.houses != state.houses)
			newState.houses = props.houses
		
		return newState
	}
	componentDidUpdate(prevProps, prevState)
	{
		if (this.state.selectedDoors != prevState.selectedDoors)
		{
			this.getPermissions()
		}
	}
	componentWillUnmount()
	{
		window.removeEventListener('keydown', this.onKeyDown)
      	window.removeEventListener('keyup', this.onKeyUp)
	}

	render()
	{
		const { TabPane } = Tabs;
		const { Search } = Input;

		return (
            <div className={styles.selectDoorsContainer}>
                <div className="responsive-container">
                    <div className={styles.permissionsTopBar}>
						<div>
                            <ProgressSteps
								activeStepIndex={1}
								numDoors={this.state.selectedDoors.length}
								numUsers={this.getTotalSelectedUsers()}
							/>
                            <h3 className={styles.title}>{ strings('giveVRSelectUsersTitle') }</h3>
                            <p className={styles.subtitle}>
								{ strings('giveVRSelectUsersSubtitle') }
							</p>
                        </div>
                        <CloseIcon className={styles.closeIcon} size="22" onClick={this.state.closePermissions} />
                    </div>
					<div className={styles.permissionCenterContent}>
						<div className={styles.permissionDoubleContent}>
							<div className={styles.firstBlockContainer}>							
								<div className={ classnames([styles.firstBlock, styles.doubleTab]) }>
									<div className={styles.selectedUserTopContainer}>
										<h3 className={styles.subtitle}>
											{ strings('giveVRSelectUsersChoose') }
										</h3>
									</div>
								
									<Tabs
										activeKey={this.state.leftPaneActiveTabKey}
										defaultActiveKey={TAB_KEY_AGENDA}
										onChange={activeTab => { this.setState({ leftPaneActiveTabKey: activeTab }) }}
									>
										<TabPane
											tab={(
												<Tooltip
													title={() => <span style={{color: Colors.black80}}>{ strings('giveVRSelectUsersTooltip') }</span>}
													placement="topLeft"
													mouseEnterDelay={0}
													mouseLeaveDelay={0}
													color={Colors.white}
													style={{color: Colors.black80}}
												>
												   <div>{ strings('giveVRSelectUsersAgenda') }</div>
												</Tooltip>
											)}
											key={TAB_KEY_AGENDA}
										>
											<div className={ classnames([styles.tabOptionContent, styles.listContent]) }>
												<div className="permissionTypeOptionsToolbar">
													<div className="left">
														<div className={styles.searchContainer}>
															<input
																placeholder={`${strings('search')}...`}
																className={classnames(styles.searchInput, {[styles.hasText]: (this.searchText != null && this.searchText.length > 0)})}
																onChange={this.searchContact}
															/>
														</div>
													</div>
													
													{
														(this.state.users.length > 0) &&
														<div className="right">
															<div onClick={() => this.selectAllAgendaList()}>{ strings('giveVRSelectUsersSelectAll') }</div>
														</div>
													}
												</div>
												
												<div className='permissionTypeOptions'>
													{ this.renderUsers() }
												</div>
											</div>
										</TabPane>
										<TabPane tab={ strings('giveVRSelectUsersAdd') } key={TAB_KEY_ADD_MANUAL}>
											<div className={ classnames([styles.tabOptionContent, styles.listContent]) }>
												<div className={styles.importUser}>
													<h4 className={styles.subtitle}>{ strings('giveVRSelectUsersAddManually') }</h4>
													<div className={classnames('permissionTypeOptions', styles.permissionTypeOptions)}>
														<div className={styles.manualInputsContainer}>
															<input
																type="text"
																className="input"
																style={{ width: '100%' }}
																placeholder={ strings('name') }
																value={this.state.name}
																onChange={(e) => this.setState({ name: e.target.value })}
															/>
															<div>
																<input
																	type="email"
																	className="input"
																	placeholder={ strings('email') }
																	value={this.state.email}
																	onChange={(e) => this.setState({ email: e.target.value })}
																/>
																<div>ó</div>
																<input
																	type="phone"
																	className="input"
																	placeholder={ strings('phone') }
																	value={this.state.phoneNumber}
																	onChange={(e) => this.setState({ phoneNumber: e.target.value })}
																	onKeyDown={(e) => { if (e.key === 'Enter' && this.validateFields()) { this.addManualUser() }}}
																/>
															</div>
														</div>
														<div className={styles.btnContainer}>
															<PrimaryButton
																text={strings('add')}
																onClick={() => { if (this.validateFields()) { this.addManualUser() }}}
															/>
														</div>
													</div>
												</div>
												<div className={styles.importUser}>
													<h4 className={styles.subtitle}>{ strings('giveVRSelectUsersImportMultiple') }</h4>
													<div className={classnames('permissionTypeOptions', styles.permissionTypeOptions)}>
														<div
															className={ classnames([styles.box, styles.importElements])}
															onClick={() => this.setState({ openImportUserModal: true })}
														>
															<div className={styles.leftBlock}>
																<img className={styles.icon} src={DownloadFileIcon} />
															</div>
															<div className={styles.rightBlock}>
																<h4 className={styles.subtitle}>{ strings('giveVRSelectUsersAddBatches') }</h4>
																<div className={styles.dropContent}>
																	{ strings('giveVRSelectUsersAddBatchesText') }
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</TabPane>
									</Tabs>
								</div>
								<code>{ strings('giveVRSelectUsersTip') }</code>
							</div>
							<div className={styles.middleBlock}>
								<ArrowRightIcon />
							</div>
							<div className={styles.secondBlockContainer}>
								<div className={styles.secondBlock}>
									<div className={styles.selectedUserTopContainer}>
										<h3 className={styles.subtitle}>
											{ strings('giveVRSelectUsersSelected') }
											{
												(this.getTotalSelectedUsers() > 0) &&
												<span className={styles.totalSelectedUsers}>({this.getTotalSelectedUsers()})</span>
											}
										</h3>
									</div>
									
									<div className={styles.permissionSelectedList}>
										<Tabs
											activeKey={this.state.rightPaneActiveTabKey}
											defaultActiveKey={TAB_KEY_IMPORTED_AGENDA}
											onChange={activeTab => this.setState({ rightPaneActiveTabKey: activeTab })}
										>
											<TabPane tab={strings('giveVRSelectUsersFromAgenda') + ' ' + `(${this.state.selectedAgendaUsers.length})`} key={TAB_KEY_IMPORTED_AGENDA}>
												<div className={styles.tabOptionContent}>	
													{
														(this.state.selectedAgendaUsers.length > 0) ?											
														<div className="permissionTypeOptionsToolbar">
															<div className="left">
																<div className={styles.searchContainer}>
																	<input
																		value={this.state.agendaSelectedContactsSearch}
																		placeholder={`${strings('search')}...`}
																		className={classnames(styles.searchInput, {[styles.hasText]: (this.state.agendaSelectedContactsSearch != null && this.state.agendaSelectedContactsSearch.length > 0)})}
																		onChange={this.searchAgendaSelectedContacts}
																	/>
																</div>
															</div>
															
															<div className="right">
																<div className="red" onClick={() => this.cleanSelectedAgendaList()}>{ strings('giveVRSelectUsersDeleteAll') }</div>
															</div>
														</div>
														:
														<div className={styles.emptyDataContainer}>
															<Empty
																image={<NoUsersIcon />}
																description={strings('giveVRUsersFromAgendaNoData')}
															/>
														</div>
													}
													
													<div className='permissionTypeOptions'>
														{ this.renderSelectedUsersList() }
													</div>
												</div>
											</TabPane>
											<TabPane tab={strings('giveVRSelectUsersManually') + ' ' + `(${this.state.usersManuallyUploaded.length})`} key={TAB_KEY_IMPORTED_MANUAL}>												
												{
													(this.state.usersManuallyUploaded.length > 0) ?
													<div className="permissionTypeOptionsToolbar">
														<div className="left">
															<div className={styles.searchContainer}>
																<input
																	value={this.state.manualSelectedContactsSearch}
																	placeholder={`${strings('search')}...`}
																	className={classnames(styles.searchInput, {[styles.hasText]: (this.state.manualSelectedContactsSearch != null && this.state.manualSelectedContactsSearch.length > 0)})}
																	onChange={this.searchManualSelectedContacts}
																/>
															</div>
														</div>
														
														<div className="right">
															<div className="red" onClick={() => this.cleanSelectedManualList()}>{ strings('giveVRSelectUsersDeleteAll') }</div>
														</div>
													</div>
													:
													<div className={styles.emptyDataContainer}>
														<Empty
															image={<NoUsersIcon />}
															description={strings('giveVRUsersManuallyNoData')}
														/>
													</div>
												}

												<div className={styles.tabOptionContent}>
													{ this.renderManuallyUploadedUsers() }
												</div>
											</TabPane>
										</Tabs>
									</div>
								</div>
							</div>
						</div>
					</div>
                    
                    <div className={styles.footerBtnPosition}>
						<PrimaryButton
							text={strings('back')}
							onClick={() => this.props.goBack()}
							white
						/>
						
						{
							(this.state.selectedAgendaUsers.length > 0 ||
							 this.state.usersManuallyUploaded.length > 0) &&
							<PrimaryButton
								text={ strings('giveVRSelectUsersButton') }
								onClick={ () => this.onClickNext() }
							/>
						}
                    </div>

                    {
						(this.state.openImportUserModal) &&
                        <ImportUsersModal
							onUsersFileUploaded={this.onUsersFileUploaded.bind(this)}
                            onClickClose={() => this.setState({ openImportUserModal: false })}
                        />
                    }
                </div>
			</div>
		);
	}

	
	onKeyDown({ key })
	{
		if (key === 'Shift')
			this.isPressingShift = true
	}
	onKeyUp({ key })
	{
		if (key === 'Shift')
			this.isPressingShift = false
	}


	getTotalSelectedUsers()
	{
		var totalUsers = (this.state.selectedAgendaUsers.length + this.state.usersManuallyUploaded.length)
		return totalUsers
	}

	// CHOOSE USERS - FROM AGENDA
	renderUsers()
	{
		let afterSearchContacts = this.getAfterSearchContacts()
		
		return (
			afterSearchContacts.map((contact) =>
			(
				<div key={contact.id} className='permissionTypeItem'>
					<Checkbox
						value={contact.id}
						checked={this.state.selectedAgendaUsers.some((user) => user.id === contact.id)}
						onChange={(event) => this.onClickContactsUser(contact, event.target.checked)}
					>
						<div className='permissionTextBlock'>
							<p className='text fw-300'>{contact.name} <b className="fw-600">{contact.lastName}</b></p>
							{/*
							<div
								className={`iconContent${this.state.showDoors ? " show" : ""}`}
								onMouseEnter={() => this.setState({ showDoors: true, userId: contact.id })}
								onMouseLeave={() => this.setState({ showDoors: false })}
								style={{ position: 'relative' }}
							>
								{
									((this.state.showDoors) && (this.state.userId === contact.id)) &&
									<div className='doorsDetailBoxContainer'>
										<div className='arrowBox'></div>
										<div className='showDoorsDialog'>
											{
												contact.doors.map((door) => (
													<p key={door.id}>{door.name}</p>
												))
											}
										</div>
									</div>
								}
								<span className='number'>
									{contact.doors.length}
								</span>
								<GaragesIcon
									size='18'
									color='rgba(29,38,38,0.6)'
									className='houseIcon'
									textClassName={styles.garageIconText}
									onClick={() => {}}
								/>
							</div>
							*/}
						</div>
					</Checkbox>
				</div>
			))
        )
	}
	onClickContactsUser(user, checked)
    {
		this.setState({ rightPaneActiveTabKey: TAB_KEY_IMPORTED_AGENDA })
		
		if (this.isPressingShift &&
			(this.lastCheckedUserId != null || this.lastUncheckedUserId != null) &&
			(this.lastCheckedUserId != user.id && this.lastUncheckedUserId != user.id))
		{
			let afterSearchContacts = this.getAfterSearchContacts()
			
			if (!checked)
			{
				let lastUncheckedUserIndex = afterSearchContacts.findIndex(c => c.id === this.lastUncheckedUserId)
				let currentUncheckedUserIndex = afterSearchContacts.findIndex(c => c.id === user.id)
				
				let minIndex = Math.min(lastUncheckedUserIndex, currentUncheckedUserIndex)
				let maxIndex = Math.max(lastUncheckedUserIndex, currentUncheckedUserIndex)
				
				let newSelectedUsers = afterSearchContacts.slice(minIndex, maxIndex+1)
				newSelectedUsers = this.state.selectedAgendaUsers.filter(u => !newSelectedUsers.some(su => su.id === u.id))
				
				this.setState({ selectedAgendaUsers: newSelectedUsers })
				
				this.lastUncheckedUserId = user.id
				this.lastCheckedUserId = null
			}
			else
			{
				let lastCheckedUserIndex = afterSearchContacts.findIndex(c => c.id === this.lastCheckedUserId)
				let currentCheckedUserIndex = afterSearchContacts.findIndex(c => c.id === user.id)
				
				let minIndex = Math.min(lastCheckedUserIndex, currentCheckedUserIndex)
				let maxIndex = Math.max(lastCheckedUserIndex, currentCheckedUserIndex)
				
				let newSelectedUsers = afterSearchContacts.slice(minIndex, maxIndex+1)
				newSelectedUsers = newSelectedUsers.filter(u => !this.state.selectedAgendaUsers.some(su => su.id === u.id))
				
				let selectedAgendaUsers = [...this.state.selectedAgendaUsers]
				this.setState({ selectedAgendaUsers: selectedAgendaUsers.concat(newSelectedUsers) })
				
				this.lastCheckedUserId = user.id
				this.lastUncheckedUserId = null
			}
		}
		else
		{
			if (!checked)
			{
				this.unselectConfirmedUser(user)
				
				this.lastUncheckedUserId = user.id
				this.lastCheckedUserId = null
			}
			else
			{
				let selectedAgendaUsers = [...this.state.selectedAgendaUsers]
				this.setState({ selectedAgendaUsers: selectedAgendaUsers.concat(user) })
				
				this.lastCheckedUserId = user.id
				this.lastUncheckedUserId = null
			}
		}
	}
	unselectConfirmedUser(user)
	{
		let selectedAgendaUsers = [...this.state.selectedAgendaUsers]
		let userIndexInArray = selectedAgendaUsers.findIndex(u => u.id === user.id)
		if (userIndexInArray === -1) return
		selectedAgendaUsers.splice(userIndexInArray, 1)
		this.setState({ selectedAgendaUsers })
	}
	searchContact = event =>
	{
		this.searchText = event.target.value
        this.setState({ filter: event.target.value })
	}
	selectAllAgendaList()
	{
		let afterSearchContacts = this.getAfterSearchContacts()
		this.setState(
		{
			selectedAgendaUsers: afterSearchContacts,
			rightPaneActiveTabKey: TAB_KEY_IMPORTED_AGENDA
		})
		this.lastCheckedUserId = null
		this.lastUncheckedUserId = null
	}
	
	// SELECTED USERS - FROM AGENDA
	renderSelectedUsersList()
	{
		let selectedAgendaUsers = [...this.state.selectedAgendaUsers]
		
		if (this.state.agendaSelectedContactsSearch.length > 0)
		{
			selectedAgendaUsers = selectedAgendaUsers.filter((user) =>
			{
                const name = `${user.name} ${user.lastName}`
                return name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(this.state.agendaSelectedContactsSearch.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
			})
		}
		
		selectedAgendaUsers.sort((userA, userB) => userA.lastName.localeCompare(userB.lastName))
		
		return (
			selectedAgendaUsers.map((user) => (
				<div key={user.id} className='permissionTypeItem'>
					<div className='permissionTextBlock'>
						<p className='text fw-300'>{user.name} <b className="fw-600">{user.lastName}</b></p>
						<div>
							<TrashIcon size="18" color="rgb(255,59,48)" className='deleteIconList' onClick={() => this.unselectConfirmedUser(user)} />
						</div>
					</div>
				</div>
			))
		)
	}
	cleanSelectedAgendaList()
	{
		this.setState({ selectedAgendaUsers: [], agendaSelectedContactsSearch: '' })
	}
	searchAgendaSelectedContacts = event =>
	{
		this.setState({ agendaSelectedContactsSearch: event.target.value })
	}
	
	// SELECTED USERS - MANUALLY
	renderManuallyUploadedUsers()
	{
		let usersManuallyUploaded = [...this.state.usersManuallyUploaded]
		if (this.state.manualSelectedContactsSearch.length > 0)
		{
			usersManuallyUploaded = usersManuallyUploaded.filter((user) =>
			{
                const name = `${user.name} ${user.email}`
                return name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(this.state.manualSelectedContactsSearch.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
			})
		}
		//usersManuallyUploaded.sort((userA, userB) => userA.name.localeCompare(userB.name))
		
		return (
		<>
			<div className='permissionTypeOptions'>
				{
					usersManuallyUploaded.map((user) => (
						this.renderManuallyUploadedUser(user)
					))
				}
			</div>
		</>)
	}
	renderManuallyUploadedUser(user)
	{
		return (
			<div key={`${user.name}-${user.email}`} className='permissionTypeItem'>
				<div>
					<div className='permissionTextBlock'>
						<p className='text fw-300'>
							{ user.name }
							<b className='fw-600'>
							{
								` (${user.email.length > 0 ? (user.phoneNumber.length > 0 ? `${user.email}/${user.phoneNumber}` : user.email) : user.phoneNumber})`
							}
							</b>
						</p>
						<div>
							<TrashIcon size="18" color="rgb(255,59,48)" className='deleteIconList' onClick={() => this.removeImportedConfirmedUser(user)} />
						</div>
					</div>
				</div>
			</div>
		)
	}
	validateFields()
    {
        let allOk = true
		let name = this.state.name.trim()
		let email = this.state.email.trim()
		let phoneNumber = this.state.phoneNumber.trim()
		const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		const phoneRegex = /^[+](.+\d{7})$/

        if (name.length === 0 ||
			(email.length === 0 && phoneNumber.length === 0))
        {
            allOk = false
			notification.error(
			{
				message: strings('fillInAllTheFields'),
				placement: 'top'
			})
        }
        else if (email.length && !emailRegex.test(email))
        {
            allOk = false
			notification.error(
			{
				message: strings('emailHasWrongFormat'),
				placement: 'top'
			})
        }
		else if (phoneNumber.length && !phoneRegex.test(phoneNumber))
        {
            allOk = false
			notification.error(
			{
				message: strings('phoneHasWrongFormat'),
				placement: 'top'
			})
        }

        return allOk
	}
	addManualUser()
	{
		let user =
        {
            name: this.state.name.trim(),
            email: this.state.email.trim().toLowerCase(),
			phoneNumber: this.state.phoneNumber.trim()
		}
		
		let userIndexInArray = this.state.usersManuallyUploaded.findIndex(u => u.email === user.email)
		if (userIndexInArray !== -1)
			userIndexInArray = this.state.usersManuallyUploaded.findIndex(u => u.phoneNumber === user.phoneNumber)
		if (userIndexInArray !== -1) return

		this.setState(
		{
			usersManuallyUploaded: this.state.usersManuallyUploaded.concat(user),
			rightPaneActiveTabKey: TAB_KEY_IMPORTED_MANUAL,
			name: '',
			email: '',
			phoneNumber: ''
		})
		
		notification.success(
		{
			message: "Usuario añadido a la lista de usuarios seleccionados",
			placement: 'top'
		})
	}
	removeImportedConfirmedUser(user)
	{
		let usersManuallyUploaded = [...this.state.usersManuallyUploaded]
		let userIndexInArray = usersManuallyUploaded.findIndex(u => u === user)
		if (userIndexInArray !== -1)
		{
			usersManuallyUploaded.splice(userIndexInArray, 1)
			this.setState({ usersManuallyUploaded })
		}
	}
	cleanSelectedManualList()
	{
		this.setState(
		{
			usersManuallyUploaded: [],
			manualSelectedContactsSearch: ''
		})
	}
	searchManualSelectedContacts = event =>
	{
		this.setState({ manualSelectedContactsSearch: event.target.value })
	}

    getPermissions()
	{
		// Get houses from door.houseId, then get all doors from that house
		let selectedHouses = this.state.houses.filter(h => this.state.selectedDoors.some(sd => sd.houseId === h.id))
		let selectedHousesDoorIds = []
		selectedHouses.forEach(sh =>
		{
			if (sh.doors)
			{
				let doorsIds = sh.doors.map(d => d.id)
				selectedHousesDoorIds.push(...doorsIds)
			}
			else if (sh.nodes)
			{
				sh.nodes.forEach(n =>
				{
					if (n.doors)
					{
						let doorsIds = n.doors.map(d => d.id)
						selectedHousesDoorIds.push(...doorsIds)
					}
				})
			}
		})
		
		this.lastCheckedUserId = null
		this.lastUncheckedUserId = null
		this.setState(
		{
			users: [],
			contacts: [],
			selectedDoors: [],
			usersManuallyUploaded: []
		}, () =>
		{
			selectedHousesDoorIds.forEach((doorId) =>
			{
				console.log(`Getting permissions for door ${doorId}`)
				
				API.getInstance().getPermissions(doorId)
				.then(response =>
				{
					if (response.data != null && response.data.permissions != null)
					{
						this.setState(
						{
							users: [...this.state.users, ...response.data.permissions],
							contacts: this.getNewContactsFromPermissions(response.data.permissions),
						})
					}
					else
					{
						notification.error(
						{
							message: strings('getPermissionsError'),
							placement: 'top'
						})
					}
				})
				.catch(error =>
				{
					console.log(error)
					notification.error(
					{
						message: strings('getPermissionsError'),
						placement: 'top'
					})
				})
			})
		})
	}
	getNewContactsFromPermissions(permissions)
	{
		let newContacts = []
		permissions.forEach((permission) =>
		{
			let userFound = this.state.contacts.some((c) => c.id === permission.user.id) ||
							newContacts.some((c) => c.id === permission.user.id)
			if (!userFound)
			{
				let user = { 
					id: permission.user.id,
					name: permission.user.name,
					lastName: permission.user.lastName,
					email: permission.user.email,
					phoneNumber: permission.user.phoneNumber
				}
				let allUsersLikeThisOne = this.state.users.filter((p) => p.user.id === permission.user.id)
				let userDoors = allUsersLikeThisOne.map((p) => p.PermissionDoor)
				user.doors = userDoors
				newContacts.push(user)
			}
		})
		
		newContacts = [...newContacts, ...this.state.contacts]
		
		newContacts.sort((userA, userB) => userA.lastName.localeCompare(userB.lastName))
		
		return newContacts
	}
	getAfterSearchContacts()
	{
		let afterSearchContacts = [...this.state.contacts]
		
		if (this.searchText.length > 0)
		{
			afterSearchContacts = afterSearchContacts.filter((contact) =>
			{
                const name = `${contact.name} ${contact.lastName}`
                return name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(this.searchText.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
			})
		}
		
		return afterSearchContacts
	}

	onUsersFileUploaded(users)
	{
		this.setState(
		{
			usersManuallyUploaded: [...this.state.usersManuallyUploaded, ...users],
			rightPaneActiveTabKey: TAB_KEY_IMPORTED_MANUAL
		})
	}
	validateUserHasEnoughVRs()
	{
		let userHasEnoughVRs = true
		let totalVRsNeededPerDoor = this.getTotalSelectedUsers()
		for (let i = 0; i < this.state.selectedDoors.length && userHasEnoughVRs; i++)
		{
			let d = this.state.selectedDoors[i]
			let freeVRs = d.myPermission?.virtualRemotes?.filter(vr => !vr.assignedUserId && !vr.reserved)
			if (freeVRs.length < totalVRsNeededPerDoor)
				userHasEnoughVRs = false
		}
		
		if (!userHasEnoughVRs)
		{
			notification.error(
			{
				message: 'No tienes suficientes Mandos Virtuales',
				description : <code>Necesitas <b>{totalVRsNeededPerDoor} Mandos Virtuales</b> disponibles por puerta. Elimina primero algún permiso o adquiere más Mandos Virtuales.</code>,
				placement: 'top'
			})
		}
		
		return userHasEnoughVRs
	}
    onClickNext()
    {
		if (this.validateUserHasEnoughVRs())
			this.props.onUsersSelected(this.state.selectedAgendaUsers, this.state.usersManuallyUploaded)
    }
}
